u.ToggleHover = class extends u.ForElement {
    /**
     *
     */
    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.addEventListener('mouseover', (evt) => {
            evt.preventDefault();
            this.$forElement.$open();
        });
        this.addEventListener('mouseout', (evt) => {
            evt.preventDefault();
            this.$forElement.$close();
        });
    }

};
u.ToggleHover.register('u-toggle-hover');
